<template>
  <div class="page-container">
    <NavBar @language-changed="handleLanguageChange" />

    <BusinessDetails 
      v-if="currentStep === 'details'" 
      @next="handleBusinessDetailsNext"
    />

    <BusinessExperience 
      v-if="currentStep === 'experience'"
      @next="handleBusinessExperienceNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <BusinessEmployees 
      v-if="currentStep === 'employees'"
      @next="handleBusinessEmployeesNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <BusinessAddress
      v-if="currentStep === 'address'"
      @next="handleBusinessAddressNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <BusinessProgress
      v-if="currentStep === 'progress'"
      @next="handleBusinessProgressNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <BusinessGoals
      v-if="currentStep === 'goals'"
      @next="handleBusinessGoalsNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <BusinessCategory
      v-if="currentStep === 'business_category'"
      @next="handleBusinessCategoryNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <SaveProgress
      v-if="currentStep === 'save_progress'"
      @next="handleSaveProgressNext"
      @back="handleBack"
    />

    <RegisteredAgent
      v-if="currentStep === 'registered_agent'"
      @next="handleRegisteredAgentNext"
      @back="handleBack"
    />

    <Compliance
      v-if="currentStep === 'worry_free_compliance'"
      @next="handleComplianceNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <EinDocuments
      v-if="currentStep === 'ein_documents'"
      @next="handleEinDocumentsNext"
      @back="handleBack"
      @skip="handleSkip"
    />

    <OperatingAgreement
      v-if="currentStep === 'operating_agreement'"
      @next="handleOperatingAgreementNext"
      @back="handleBack"
    />

    <!-- Pricing Modal -->
    <PricingModal
      :show="showPricingModal"
      :loading="modalState.loading"
      :error="modalState.error"
      :success="modalState.success"
      @close="closePricingModal"
      @select="selectPackage"
    />
  </div>
</template>

<script>
import '@/styles/CustomerBusiness.css'
import businessRegistrationService from '@/services/businessRegistrationService';
import NavBar from '@/components/NavBar.vue';
import BusinessDetails from '@/components/BusinessDetails.vue';
import BusinessExperience from '@/components/BusinessExperience.vue';
import BusinessEmployees from '@/components/BusinessEmployees.vue';
import BusinessAddress from '@/components/BusinessAddress.vue';
import BusinessProgress from '@/components/BusinessProgress.vue';
import BusinessGoals from '@/components/BusinessGoals.vue';
import BusinessCategory from '@/components/BusinessCategory.vue';
import SaveProgress from '@/components/SaveProgress.vue';
import RegisteredAgent from '@/components/RegisteredAgent.vue';
import Compliance from '@/components/Compliance.vue';
import EinDocuments from '@/components/EinDocuments.vue';
import OperatingAgreement from '@/components/OperatingAgreement.vue';
import PricingModal from '@/components/PricingModal.vue';
import axios from 'axios';

export default {
  name: 'CustomerBusiness',
  components: {
    NavBar,
    BusinessDetails,
    BusinessExperience,
    BusinessEmployees,
    BusinessAddress,
    BusinessProgress,
    BusinessGoals,
    BusinessCategory,
    SaveProgress,
    RegisteredAgent,
    Compliance,
    EinDocuments,
    OperatingAgreement,
    PricingModal
  },
  data() {
    return {
      currentStep: 'details',
      businessName: '',
      alternativeName: '',
      formationState: '',
      businessExperience: 'none',
      employeeCount: 'none',
      differentAddress: false,
      businessAddress: {
        street: '',
        city: '',
        state: '',
        zipCode: '',
        country: 'USA'
      },
      ownerDetails: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
      ownerAddress: {
        streetAddress: '',
        city: '',
        state: '',
        zipCode: ''
      },
      businessProgress: 'launching',
      businessGoals: 'side',
      businessCategory: '',
      saveProgress: false,
      registeredAgent: '',
      showPricingModal: false,
      selectedPackage: '',
      worryFreeCompliance: false,
      selectedDocuments: '',
      operatingAgreement: '',
      modalState: {
        loading: false,
        error: null,
        success: false
      },
      states: [
        'Utah'
      ],
      customerId: null,
      tempOwnerInfo: null,
      tempOwnerAddress: null,
      tempBusinessAddress: null,
      isSubmitting: false
    }
  },
  methods: {
    handleLanguageChange(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);
    },
    handleBusinessDetailsNext(data) {
      this.businessName = data.businessName;
      this.alternativeName = data.alternativeName;
      this.formationState = data.formationState;
      this.currentStep = 'experience';
    },
    handleBusinessExperienceNext(data) {
      this.businessExperience = data.businessExperience;
      this.currentStep = 'employees';
    },
    handleBusinessEmployeesNext(data) {
      this.employeeCount = data.employeeCount;
      this.currentStep = 'save_progress';
    },
    handleBusinessAddressNext(data) {
      this.differentAddress = data.differentAddress;
      this.businessAddress = data.businessAddress;

      if (data.businessAddress) {
        this.tempBusinessAddress = {
          ...data.businessAddress,
          addressType: 'Business',
          isDefault: true
        };
      }

      this.currentStep = 'progress';
    },
    handleBusinessProgressNext(data) {
      this.businessProgress = data.businessProgress;
      this.currentStep = 'goals';
    },
    handleBusinessGoalsNext(data) {
      this.businessGoals = data.businessGoals;
      this.currentStep = 'business_category';
    },
    handleBusinessCategoryNext(data) {
      this.businessCategory = data.businessCategory;
      this.currentStep = 'registered_agent';
    },
    async handleSaveProgressNext(data) {
      this.saveProgress = data.saveProgress;
      this.ownerDetails = data.ownerDetails;
      this.ownerAddress = data.ownerAddress;
      
      // Store customer data temporarily
      if (data.ownerDetails) {
        this.tempOwnerInfo = {
          firstName: data.ownerDetails.firstName.trim(),
          lastName: data.ownerDetails.lastName.trim(),
          email: data.ownerDetails.email.trim(),
          password: '123456', // Default password
          phone: data.ownerDetails.phone.trim(), // Changed from phoneNumber to phone
          role: 'BusinessOwner',
          status: 'Active'
        };
      }
      
      // Store address data temporarily
      if (data.ownerAddress) {
        this.tempOwnerAddress = {
          ...data.ownerAddress,
          addressType: 'Owner',
          isDefault: true
        };
      }

      // Proceed to next step
      this.currentStep = 'address';
    },
    handleRegisteredAgentNext(data) {
      this.registeredAgent = data.registeredAgent;
      this.showPricingModal = true;
    },
    handleComplianceNext(data) {
      this.worryFreeCompliance = data.worryFreeCompliance;
      this.currentStep = 'ein_documents';
    },
    handleEinDocumentsNext(data) {
      this.selectedDocuments = data.selectedDocuments;
      this.currentStep = 'operating_agreement';
    },
    handleOperatingAgreementNext(data) {
      this.operatingAgreement = data.operatingAgreement;
      this.handleOperatingSubmit();
    },
    handleBack() {
      switch (this.currentStep) {
        case 'experience':
          this.currentStep = 'details';
          break;
        case 'employees':
          this.currentStep = 'experience';
          break;
        case 'save_progress':
          this.currentStep = 'employees';
          break;
        case 'address':
          this.currentStep = 'save_progress';
          break;
        case 'progress':
          this.currentStep = 'address';
          break;
        case 'goals':
          this.currentStep = 'progress';
          break;
        case 'business_category':
          this.currentStep = 'goals';
          break;
        case 'registered_agent':
          this.currentStep = 'business_category';
          break;
        case 'worry_free_compliance':
          this.currentStep = 'registered_agent';
          break;
        case 'ein_documents':
          this.currentStep = 'worry_free_compliance';
          break;
        case 'operating_agreement':
          this.currentStep = 'ein_documents';
          break;
        default:
          console.log('No back action defined for current step:', this.currentStep);
      }
    },
    handleSkip() {
      switch (this.currentStep) {
        case 'experience':
          this.currentStep = 'employees';
          break;
        case 'employees':
          this.currentStep = 'save_progress';
          break;
        case 'address':
          this.currentStep = 'progress';
          break;
        case 'progress':
          this.currentStep = 'goals';
          break;
        case 'goals':
          this.currentStep = 'business_category';
          break;
        case 'business_category':
          this.currentStep = 'registered_agent';
          break;
        case 'worry_free_compliance':
          this.currentStep = 'ein_documents';
          break;
        case 'ein_documents':
          this.currentStep = 'operating_agreement';
          break;
        default:
          console.log('No skip action defined for current step:', this.currentStep);
      }
    },
    closePricingModal() {
      this.showPricingModal = false;
      this.modalState.error = null;
      this.modalState.success = false;
    },
    async selectPackage(packageType) {
      try {
        this.modalState.loading = true;
        this.modalState.error = null;

        // Validate package selection
        if (!packageType) {
          throw new Error('Please select a package');
        }

        // Simulate API call to save package selection
        await new Promise(resolve => setTimeout(resolve, 1000));

        this.selectedPackage = packageType;
        this.showPricingModal = false;
        this.modalState.success = true;

        // Navigate to next step after package selection
        if (packageType === 'starter') {
          this.currentStep = 'worry_free_compliance';
        }
      } catch (error) {
        this.modalState.error = error.message || 'Failed to select package. Please try again.';
      } finally {
        this.modalState.loading = false;
      }
    },
    async handleOperatingSubmit() {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      try {
        let customerId;

        // Step 1: Check if customer exists
        try {
          const checkCustomerResult = await businessRegistrationService.checkExistingCustomer(this.tempOwnerInfo.email);
          if (checkCustomerResult.exists) {
            customerId = checkCustomerResult.customerId;
            console.log('Using existing customer with ID:', customerId);
          } else {
            // Step 2: Create new customer
            const customerResponse = await businessRegistrationService.createCustomer(this.tempOwnerInfo);
            if (!customerResponse.success) {
              throw new Error('Failed to create customer');
            }
            customerId = customerResponse.data.id;
            console.log('New customer created with ID:', customerId);
          }
        } catch (error) {
          console.error('Error in customer creation/check:', error);
          throw new Error('Failed to process customer information. Please try again.');
        }

        // Step 3: Create business
        const businessPayload = {
          legalBusinessName: this.businessName,
          alternativeName: this.alternativeName,
          tradeName: '',
          status: 'Draft',
          // Required fields
          responsiblePartyName: `${this.ownerDetails.firstName} ${this.ownerDetails.lastName}`.trim(),
          ssn: 'To be provided in EIN form',
          role: 'Owner',
          businessActivity: this.businessCategory || 'General Business',
          entityType: 'LLC',
          reasonForApplying: 'Starting a new business',
          startDate: new Date().toISOString(),
          willHireEmployees: this.employeeCount !== 'none',
          taxReturnsType: 'Annual',
          yearEndDate: new Date(new Date().getFullYear(), 11, 31).toISOString(),
          signature: 'Pending',
          declarationDate: new Date().toISOString(),
          // Additional fields
          businessExperience: this.businessExperience.charAt(0).toUpperCase() + this.businessExperience.slice(1),
          employeeCount: this.employeeCount.charAt(0).toUpperCase() + this.employeeCount.slice(1),
          differentAddress: this.differentAddress,
          businessProgress: this.businessProgress.charAt(0).toUpperCase() + this.businessProgress.slice(1),
          businessGoals: this.businessGoals.charAt(0).toUpperCase() + this.businessGoals.slice(1).replace('_', ' '),
          businessCategory: this.businessCategory,
          saveProgress: this.saveProgress,
          selectedPackage: this.selectedPackage,
          worryFreeCompliance: this.worryFreeCompliance,
          selectedDocuments: this.selectedDocuments.charAt(0).toUpperCase() + this.selectedDocuments.slice(1),
          operatingAgreement: this.operatingAgreement.charAt(0).toUpperCase() + this.operatingAgreement.slice(1)
        };

        const businessResponse = await businessRegistrationService.createBusiness(businessPayload);
        if (!businessResponse.success) {
          throw new Error(businessResponse.error || 'Failed to create business');
        }

        const businessId = businessResponse.data.id;
        console.log('Business created successfully with ID:', businessId);

        // Step 4: Create owner info
        const ownerInfoPayload = {
          firstName: this.ownerDetails.firstName,
          lastName: this.ownerDetails.lastName,
          email: this.ownerDetails.email,
          phoneNumber: this.ownerDetails.phone,
          isPrimary: true
        };

        const ownerResponse = await businessRegistrationService.createOwnerInfo(businessId, ownerInfoPayload);
        if (!ownerResponse.success) {
          throw new Error(ownerResponse.error || 'Failed to create owner info');
        }
        console.log('Owner info created successfully');

        // Step 5: Create addresses
        if (this.tempOwnerAddress) {
          const ownerAddressResponse = await businessRegistrationService.createAddress(businessId, {
            streetAddress: this.tempOwnerAddress.streetAddress,
            city: this.tempOwnerAddress.city,
            state: this.tempOwnerAddress.state,
            zipCode: this.tempOwnerAddress.zipCode,
            addressType: 'Owner',
            isDefault: true
          });
          
          if (!ownerAddressResponse.success) {
            throw new Error(ownerAddressResponse.error || 'Failed to create owner address');
          }
          console.log('Owner address created successfully');
        }

        if (this.differentAddress && this.tempBusinessAddress) {
          const businessAddressResponse = await businessRegistrationService.createAddress(businessId, {
            streetAddress: this.tempBusinessAddress.streetAddress,
            city: this.tempBusinessAddress.city,
            state: this.tempBusinessAddress.state,
            zipCode: this.tempBusinessAddress.zipCode,
            addressType: 'Business',
            isDefault: true
          });
          
          if (!businessAddressResponse.success) {
            throw new Error(businessAddressResponse.error || 'Failed to create business address');
          }
          console.log('Business address created successfully');
        }

        // Step 6: Create CustomerBusiness relationship
        const linkResponse = await businessRegistrationService.linkCustomerToBusiness(
          customerId,
          businessId,
          'BusinessOwner'
        );
        
        if (!linkResponse.success) {
          throw new Error('Failed to link customer with business');
        }
        console.log('Customer linked to business successfully');

        // Clear temporary data
        this.tempOwnerInfo = null;
        this.tempOwnerAddress = null;
        this.tempBusinessAddress = null;

        // Set setup complete flag
        localStorage.setItem('isSetupComplete', 'true');
        
        // Show success message
        alert('Business registration completed successfully!');
        
        // Navigate to RegistrationSuccess view
        this.$router.push({ name: 'RegistrationSuccess'});
      } catch (error) {
        console.error('Error in business registration:', error);
        alert(error.message || 'Failed to complete business registration. Please try again.');
      } finally {
        this.isSubmitting = false;
      }
    },
    async createCustomer(customerData) {
      try {
        console.log('Creating customer with data:', customerData);
        const response = await axios.post(process.env.VUE_APP_API_URL + '/customers', customerData);
        console.log('Customer creation response:', response.data);
        return response;
      } catch (error) {
        console.error('Error creating customer:', error.response?.data || error);
        throw new Error(error.response?.data?.error || error.message || 'Failed to create customer');
      }
    },
    async createOwnerAddress(ownerAddressData) {
      try {
        const response = await axios.post(process.env.VUE_APP_API_URL + '/owner-addresses', ownerAddressData);
        return response.data;
      } catch (error) {
        console.error('Error creating owner address:', error);
        throw error;
      }
    },
    async createBusinessAddress(businessAddressData) {
      try {
        const response = await axios.post(process.env.VUE_APP_API_URL + '/business-addresses', businessAddressData);
        return response.data;
      } catch (error) {
        console.error('Error creating business address:', error); 
        throw error;
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem('language') || 'en';
    this.$i18n.locale = savedLanguage;
  }
}
</script>
